import type { CSSInterpolation } from '@emotion/serialize';
import { Children, type ReactNode } from 'react';

import { typography } from '@adflow/frontend/ui-theme';

import { entryLayoutStyles } from '../styles';

export interface HistoryEntryFieldLayoutProps {
	label: string;
	children: ReactNode;
	itemStyles?: CSSInterpolation;
	contentStyles?: CSSInterpolation;
}
export function HistoryEntryFieldLayout({
	label,
	children,
	itemStyles,
	contentStyles,
}: HistoryEntryFieldLayoutProps) {
	const normalizedChildren = Children.toArray(children);

	return (
		<div css={[entryLayoutStyles.item, itemStyles]}>
			<label css={typography.label}>{label}</label>
			<div
				css={[{ maxWidth: '100%', overflowWrap: 'break-word' }, contentStyles]}
			>
				{normalizedChildren}
			</div>
		</div>
	);
}
